
export default {
  name: 'RecruitLinkList'
}
